<div class="step-header" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div class="title">Review</div>
</div>
<div class="content" *ngIf="!wizardCtrl.getWizardService().isLoading">
  <div class="datasource-settings-container">
    <div class="header">
      <div class="icon">
        <img src="{{step.parent.output.agentType.iconName}}" />
      </div>
      <div class="title">{{step.parent.output.datasourceType.name}}</div>
    </div>
    <div class="datasource">
      <div class="header">
        <div class="icon">
          <mat-icon>settings</mat-icon>
        </div>
        <div class="label">Definition</div>
        <div
          class="edit"
          *ngIf="step.parent.output.datasourceType.id !== 'GigaTestAgent'"
          (click)="wizardCtrl.editHost()"
        >
          EDIT
        </div>
        <div
          class="edit"
          *ngIf="step.parent.output.datasourceType.id === 'GigaTestAgent'"
          (click)="wizardCtrl.editAlias()"
        >
          EDIT
        </div>
      </div>
      <div
        class="datasource-settings"
        *ngIf="step.parent.output.datasourceType.id !== 'GigaTestAgent'"
      >
        <div class="key">Name:</div>
        <div class="value label">{{step.parent.output.name}}</div>
      </div>
      <div
        class="datasource-settings"
        *ngIf="step.parent.output.datasourceType.id !== 'GigaTestAgent'"
      >
        <div class="key">Host:</div>
        <div class="value label">{{dataSourceHost}}</div>
      </div>
      <div class="datasource-settings" *ngIf="step.parent.output.datasourceType.id == 'GigaStor'">
        <div class="key">Username:</div>
        <div class="value label">{{userName}}</div>
      </div>
      <div
        class="datasource-settings"
        *ngIf="step.parent.output.datasourceType.id == 'GigaTestAgent'"
      >
        <div class="key">Alias:</div>
        <div class="value label">{{step.parent.output.alias}}</div>
      </div>
      <div
        class="datasource-settings"
        *ngIf="step.parent.output.datasourceType.id == 'GigaTestAgent'"
      >
        <div class="key">Agent type:</div>
        <div class="value label">{{step.parent.output.agentType.label}}</div>
      </div>
      <div
        class="datasource-settings"
        *ngIf="step.parent.output.datasourceType.id == 'GigaTestAgent' && 
      step.parent.output.agentType.id === 'hardware'"
      >
        <div class="key">CLAIM code:</div>
        <div class="value label">{{step.parent.output.hwLockCode}}</div>
      </div>
    </div>
    <div class="datasource" *ngIf="step.parent.output.datasourceType.id !== 'GigaFlowServer'">
      <div class="header">
        <div class="icon"><img src="images/site.svg" /></div>
        <div class="label">Site information</div>
        <div
          class="edit"
          (click)="wizardCtrl.editSite()"
          *ngIf="wizardCtrl.isValidStep('datasource_location')"
        >
          EDIT
        </div>
      </div>
      <div class="datasource-settings">
        <div class="key">Name:</div>
        <div class="value label">
          <div class="name">{{step.parent.output.siteName}}</div>
        </div>
      </div>
      <div class="datasource-settings">
        <div class="key">Location:</div>
        <div class="value label">
          <div class="city">{{locationName}}</div>
        </div>
      </div>
    </div>

    <!-- icon, platform, address, subnet, gateway, dns, ntp -->
    <div
      *ngIf="step.parent.output.datasourceType.id === 'GigaTestAgent' && 
    step.parent.output.agentType.id === 'virtual'"
    >
      <div class="datasource">
        <div class="header">
          <div class="icon">
            <mat-icon>settings</mat-icon>
          </div>
          <div class="label">Network settings</div>
          <div class="edit" (click)="wizardCtrl.editNetwork()">EDIT</div>
        </div>
        <div *ngIf="step.parent.output.staticIp">
          <div class="datasource-settings">
            <div class="key">IP address:</div>
            <div class="value label">
              <div class="city">{{step.parent.output.staticIp.ip}}</div>
            </div>
          </div>
          <div class="datasource-settings">
            <div class="key">Subnet:</div>
            <div class="value label">
              <div class="name">{{step.parent.output.staticIp.netmask}}</div>
            </div>
          </div>
          <div class="datasource-settings">
            <div class="key">Gateway:</div>
            <div class="value label">
              <div class="city">{{step.parent.output.staticIp.gateway}}</div>
            </div>
          </div>
          <div class="datasource-settings">
            <div class="key">DNS server(s):</div>
            <div class="value label">
              <div class="name">{{step.parent.output.staticIp.dns.join(', ')}}</div>
            </div>
          </div>
        </div>
        <div *ngIf="!step.parent.output.staticIp">
          <div class="datasource-settings">
            <div class="key">IP address:</div>
            <div class="value label">
              <div class="name">Automatically assign</div>
            </div>
          </div>
        </div>
        <!-- NTP server settings -->
        <div class="datasource-settings">
          <div class="key">NTP time service:</div>
          <div class="value label">
            <div class="name">
              {{step.parent.output.ntpServer ? step.parent.output.ntpServer : 'Automatically
              assign'}}
            </div>
          </div>
        </div>
      </div>

      <!-- webproxy, protocol, address, port -->
      <div class="datasource">
        <div class="header">
          <div class="icon">
            <mat-icon>settings</mat-icon>
          </div>
          <div class="label">Proxy settings:</div>
          <div class="edit" (click)="wizardCtrl.editProxy()">EDIT</div>
        </div>
        <div>
          <div class="datasource-settings">
            <div class="key">IP address:</div>
            <div class="value label">
              <div class="city">
                {{step.parent.output.webProxy ? step.parent.output.webProxy.protocol + '://' +
                step.parent.output.webProxy.address + ':' + step.parent.output.webProxy.port :
                'none'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
  <div class="loader-msg-header">
    <p>Adding {{step.parent.output.datasourceType.label}}</p>
  </div>
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
